import React, { Component } from 'react';
import { Button, Dialog, DialogContent, TextField, DialogContentText, DialogActions, Slide, DialogTitle, Grid, IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { connect } from 'react-redux';
import { msgSimple } from '../../actions/snackbarActions';
import { navigate } from '../../actions/routerResolve';

//alerta
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

class ModalProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newPassword: '',
      oldPassword: '',
      showPassword: false
    }
  }

  componentWillMount() {
    this.setState({
      newPassword: '',
      oldPassword: '',
      showPassword: false
    })
  }

  onRender = () => {
    this.setState({
      newPassword: '',
      oldPassword: '',
      showPassword: false
    })
  }


  handleClickShowPassword = () => {
    this.setState(({ showPassword: !this.state.showPassword }));
  };


  render() {
    return (
      <Slide direction="up">
        <Dialog
          onEnter={this.onRender}
          open={this.props.open}
          // scroll={'body'}
          onClose={this.onClose}
          md={2}
          sm={2}
          xs={2}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Alterar Senha"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Grid container spacing={8}>
                <Grid item md={12}>
                  <TextField
                    style={{ width: '100%' }}
                    value={this.state.oldPassword}
                    placeholder='Senha Atual'
                    label='Senha Atual'
                    onChange={event => {
                      this.setState({ oldPassword: event.target.value })
                    }}
                  />
                </Grid>
                <Grid item md={12}>
                  <TextField
                    type={this.state.showPassword ? 'text' : 'password'}
                    style={{ width: '100%' }}
                    value={this.state.newPassword}
                    placeholder='Nova Senha'
                    label='Nova Senha'
                    InputProps={{
                      endAdornment:
                        <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowPassword}>
                          {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    }}
                    // endAdornment={
                    //     <InputAdornment position="end">
                    //       <IconButton
                    //         aria-label="Toggle password visibility"
                    //         onClick={this.handleClickShowPassword}
                    //       >
                    //         {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    //       </IconButton>
                    //     </InputAdornment>
                    //   }
                    onChange={event => {
                      this.setState({ newPassword: event.target.value })
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.openModal}
              color="primary">
              Cancelar
                        </Button>
            <Button
              onClick={() =>
                Swal.fire({
                  title: '<strong>Deseja mesmo salvar uma nova senha?</strong>',
                  type: 'info',
                  showCloseButton: true,
                  showCancelButton: true,
                  focusConfirm: false,
                  confirmButtonText:
                    '<i class="fa fa-thumbs-up"></i> Sim',
                  confirmButtonAriaLabel: 'Sim',
                  cancelButtonText:
                    '<i class="fa fa-thumbs-down"></i> Não',
                  cancelButtonAriaLabel: 'Não',
                }).then((result) => {
                  if (!!result.value) {
                    this.props.changePassword(this.state.oldPassword, this.state.newPassword)
                  }
                  else {
                  }
                })
              }
              color="primary"
              autoFocus>
              Salvar
                        </Button>
          </DialogActions>
        </Dialog>
      </Slide>
    )
  }
}

const mapStateToProps = state => ({
  user: state.authReducer.user
})
const mapDispatchToProps = {
  navigate,
  msgSimple
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalProfile)


// WEBPACK FOOTER //
// ./src/routes/profile/Modal.js